import { NavigationGuardNext, Route } from 'vue-router'

function fromRegisterGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (to.name === 'admin:welcome' && !['register', 'login'].includes(from.name || '')) {
    return next({ name: 'admin:home' })
  }
  return next()
}

export default fromRegisterGuard
